export const environment = {
  production: false,
};

export const URL_SERVICIOS = 'https://api.tadeoviajesyturismo.com/index.php/';
export const URL_IMGS = "https://api.tadeoviajesyturismo.com/uploads/";
export const URL_PDF = "https://api.tadeoviajesyturismo.com/pdf/";
